import { sanitizeSupabaseConfig, type SupabaseConfig } from './config';

/** Build-time default from VITE_SUPABASE_URL and the publishable (or legacy anon) key. */
export function readEnvSupabase(): SupabaseConfig {
  return sanitizeSupabaseConfig({
    url: envString('VITE_SUPABASE_URL'),
    publishableKey: envString('VITE_SUPABASE_PUBLISHABLE_KEY'),
    anonKey: envString('VITE_SUPABASE_ANON_KEY'),
  });
}

function envString(
  name: 'VITE_SUPABASE_URL' | 'VITE_SUPABASE_PUBLISHABLE_KEY' | 'VITE_SUPABASE_ANON_KEY',
): string {
  const value: unknown = import.meta.env[name];
  return typeof value === 'string' ? value : '';
}
